// extracted by mini-css-extract-plugin
export default {"dialog":"DaJjeDTJdvHUDD7","title":"oLhZYbz1MCNUcQw","description":"cRGLc1_JpbmQJ8i","buttons-container":"ZcInpF0surJhxc1"};